export enum RequestStatus {
  NotInvoked,
  Pending,
  Load,
  Error,
}
